import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getCloudFilmBySerialNo as _getCloudFilmBySerialNo, getCloudFilmBySerialNoByFileType as _getCloudFilmBySerialNoByFileType, getHospitalCode } from '@/api/module/index';
import axios from "axios";
export default {
  name: 'HelloWorld',
  data: function data() {
    return {
      seroalno: '',
      projects: [],
      VUE_APP_CLOUD_FILM_DETAIL_URL: window.g.VUE_APP_CLOUD_FILM_DETAIL_URL,
      hsCode: '',
      // 医院机构代码
      VUE_APP_CLOUD_FILM_DETAIL_AES: window.g.VUE_APP_CLOUD_FILM_DETAIL_AES
    };
  },
  created: function created() {
    this.seroalno = this.$route.query.seroalno;
    console.log("seroalno", this.seroalno); // 获取医院机构代码

    this.getHscode();
  },
  methods: {
    //获取机构代码
    getHscode: function getHscode() {
      var _this = this;

      getHospitalCode().then(function (res) {
        _this.hsCode = res.data;

        if (_this.hsCode === "38-2023-05-01") {
          _this.getCloudFilmBySerialNo(_this.seroalno);

          return;
        } else {
          console.log("seroalno2", _this.seroalno); // 其他机构

          _this.getCloudFilmBySerialNoByFileType(_this.seroalno);
        }
      });
    },
    // 获取有云胶片的组合项目
    getCloudFilmBySerialNo: function getCloudFilmBySerialNo(seroalno) {
      var _this2 = this;

      console.log("seroalno", seroalno);

      _getCloudFilmBySerialNo({
        serialno: seroalno
      }).then(function (res) {
        _this2.projects = res.data;
      });
    },
    // 获取有云胶片的组合项目;查fileType为3的项目
    getCloudFilmBySerialNoByFileType: function getCloudFilmBySerialNoByFileType(seroalno) {
      var _this3 = this;

      console.log("seroalno2", seroalno);

      _getCloudFilmBySerialNoByFileType({
        serialno: seroalno
      }).then(function (res) {
        _this3.projects = res.data;
      });
    },
    // 触发第三方接口
    triggerThirdPartyInterface: function triggerThirdPartyInterface(groupid) {
      if (this.hsCode === "38-2023-05-01") {
        this.goToLuZhouFilm(groupid);
      } else {
        // 发送post 请求
        var url = '';
        url = this.projects.find(function (item) {
          return item.groupId == groupid;
        }).picPath;
        console.log('url', url);

        if (url) {
          this.goToLuZhouFilmByFileType(url);
        }
      }
    },
    // 柳州影像
    goToLuZhouFilm: function goToLuZhouFilm(groupid) {
      // 心电图不需要传groupId
      if (groupid == '1101') {
        groupid = '';
      } // 获取当前时间戳


      var timestamp = Math.floor(Date.now() / 1000); // 发送post 请求

      var params = {
        seroalno: this.seroalno,
        groupid: groupid,
        type: true
      };
      var jmParams = {
        seroalno: this.seroalno,
        groupid: groupid,
        type: true,
        timestamp: timestamp,
        Username: 'ZLSADY',
        Password: 'BHBHBH'
      }; // 拼接加密数据（包含时间戳）

      var dataToEncrypt = JSON.stringify(jmParams);
      console.log("dataToEncrypt", dataToEncrypt); // 执行 AES 加密

      var key = require('crypto-js').enc.Utf8.parse(this.VUE_APP_CLOUD_FILM_DETAIL_AES);

      var encrypted = require('crypto-js').AES.encrypt(dataToEncrypt, key, {
        mode: require('crypto-js').mode.ECB,
        padding: require('crypto-js').pad.Pkcs7
      });

      var sign = encrypted.toString();
      axios.post(this.VUE_APP_CLOUD_FILM_DETAIL_URL, params, {
        headers: {
          sign: "sign " + sign
        }
      }).then(function (res) {
        // 跳转到第三方页面
        // 截取域名替换成  https://www.gfelz.com 替换成 https://www.gfelz.com:6027/
        var url = res.data.YyxUrl;
        var domain = url.split('//')[1].split('/')[0];
        var newUrl = url.replace(domain, 'www.gfelz.com:6027');
        window.location.href = newUrl;
        console.log('跳转第三方', newUrl);
      }).catch(function (err) {});
      console.log('第三方接口已触发');
    },
    // 其他影像
    goToLuZhouFilmByFileType: function goToLuZhouFilmByFileType(url) {
      console.log('第三方接口已触发', url);
      window.location.href = url;
    }
  }
};